export const MONTH_YEAR_EN = 'Month/Year';
export const MONTH_YEAR_ID = 'Bulan/Tahun';
export const PLN_POSTPAID = 'PLN POSTPAID';
export const PLN_POSTPAID_SMALL = 'PLN Postpaid';
